import moment from 'moment';
import axiosService from '@services/axiosService';
import {
  computeOffset,
  computeTotalPages,
  computeCurrentPage,
} from '@services/paginationComputer';
import { conferenceRoutePrefix } from '@services/conferenceResource';
import SortIconEmpty from '@assets/SortIconEmpty.svg';
import SortIconUp from '@assets/SortIconUp.svg';
import SortIconDown from '@assets/SortIconDown.svg';
import { DASHBOARD } from '@config/modelsConfig';

export const counstructFilters = (props) => {
  const from = props[DASHBOARD.FILTER.FROM_DATE];
  const to = props[DASHBOARD.FILTER.TO_DATE];
  const title = (props[DASHBOARD.FILTER.TITLE] || '').trim();
  const analyst = (props[DASHBOARD.FILTER.ANALYST] || '').trim();
  const { order } = props;
  const fromQuery = from && { date: { gt: new Date(moment(from).startOf('day')) } };
  const toQuery = to && { date: { lt: new Date(moment(to).endOf('day')) } };
  const dateQuery = [fromQuery, toQuery].filter((item) => !!item);
  const where = {
    and: dateQuery.length ? dateQuery : undefined,
    title: title ? { like: `%${title}%` } : undefined,
  };
  return {
    analyst,
    where,
    order,
  };
};

export const counstructCloudSearchFilters = (props) => {
  const title = (props[DASHBOARD.FILTER.TITLE] || '').trim();

  return title;
};

export const getDashboardConferences = (pageNumber, numberPerPage, token, filters) => {
  const params = {
    access_token: token,
    filters,
    offset: pageNumber && numberPerPage && computeOffset(pageNumber, numberPerPage),
    limit: numberPerPage,
  };
  return axiosService.get(`${conferenceRoutePrefix}/dashboard-list`, { params });
};

export const getDashboardTranscripts = (pageNumber, numberPerPage, token, filters) => {
  const params = {
    access_token: token,
    filters,
    offset: pageNumber && numberPerPage && computeOffset(pageNumber, numberPerPage),
    limit: numberPerPage,
  };
  return axiosService.get('/api/TranscriptEntries/transcript-entries-list', { params });
};

export const getColudSearchTranscripts = ({ token, keyword }) => {
  return axiosService.post(
    `/api/TranscriptEntries/search?access_token=${token}&query=${keyword}`,
  );
};

/* eslint-disable-next-line */
export const getTranscriptsCount = (access_token) => {
  const payload = {
    params: {
      access_token,
    },
  };
  return axiosService.get(`${conferenceRoutePrefix}/count`, payload);
};

export const getNewOrder = (oldOrder, newField) => {
  const [oldField, oldModifier] = oldOrder.split(' ');
  const newModifier = newField !== oldField || oldModifier === 'ASC' ? 'DESC' : 'ASC';
  return `${newField} ${newModifier}`;
};

export const getIcon = (order, name) => {
  const [field, modifier] = order.split(' ');
  return (
    (field !== name && SortIconEmpty) ||
    (modifier === 'ASC' && SortIconUp) ||
    SortIconDown
  );
};

export const mapPaginationValues = (meta) => {
  const { total } = meta;
  const numberPerPage = parseInt(meta.limit);
  const totalPages = computeTotalPages(total, numberPerPage);
  const currentPage = computeCurrentPage(meta.offset, numberPerPage);
  return {
    total,
    totalPages,
    currentPage,
  };
};



// WEBPACK FOOTER //
// ./services/dashboardResource.js